export default {
    remove: 'Remove',
    save: 'Save',
    cancel: 'Cancel',
    loading: 'Loading…',
    value: 'Value',
    'action-bar.collapse': 'Collapse',
    'action-bar.expand': 'Expand',
    'action-bar.actions': 'Actions',
    'callout.note': 'Note',
    'callout.important': 'Important',
    'callout.tip': 'Tip',
    'callout.caution': 'Caution',
    'callout.warning': 'Warning',
    'collapsible-section.open': 'Open { header } section',
    'collapsible-section.close': 'Close { header } section',
    'date-picker.today': 'Today',
    'date-picker.month.heading': 'Month',
    'date-picker.quarter.heading': 'Quarter',
    'date-picker.year.heading': 'Year',
    'chip-set.clear-all': 'Clear all',
    'snackbar.dismiss': 'Dismiss',
    'file.drag-and-drop-tips':
        'Drag & drop your file here, or click to browse.',
    'file-viewer.message.unsupported-filetype':
        'Cannot display a preview for this file type.',
    'file-viewer.message.try-other-options':
        'Download the file or open it in a new tab.',
    'file-viewer.download': 'Download',
    'file-viewer.exit-fullscreen': 'Exit fullscreen',
    'file-viewer.open-in-fullscreen': 'Open in fullscreen',
    'file-viewer.open-in-new-tab': 'Open in a new tab',
    'file-viewer.more-actions': 'More…',
    'editor-menu.bold': 'Bold',
    'editor-menu.italic': 'Italic',
    'editor-menu.strikethrough': 'Strikethrough',
    'editor-menu.h1': 'Heading 1',
    'editor-menu.h2': 'Heading 2',
    'editor-menu.h3': 'Heading 3',
    'editor-menu.bulleted-list': 'Bulleted list',
    'editor-menu.numbered-list': 'Numbered list',
    'editor-menu.blockquote': 'Blockquote',
    'editor-menu.link': 'Link',
    'editor-link-menu.text': 'Text',
    'editor-link-menu.link': 'Link',
    'editor-menu.code-block': 'Code block',
    'editor-menu.code': 'Code',
    'editor-image-view.loading': 'Loading image: { filename }...',
    'editor-image-view.failed': 'Something went wrong with image: { filename }',
    'editor-image-view.success': 'Image: { filename } is ready',
    'editor-image-view.resize-handle':
        'Drag to right or left to resize the image',
    'progress-bar': 'Progress bar',
    'ai-avatar.label': 'AI Avatar',
    'ai-avatar.thinking': 'thinking',
    'table.select-all': 'Select all rows',
    'table.select-row': 'Select this row',
    'profile-picture.remove': 'Remove selected picture',
    'profile-picture.unsupported-preview.title': 'Unsupported image format',
    'profile-picture.unsupported-preview.description':
        'We cannot display the selected image in this browser. Please select a different image file.',
};
